enum SignatureTypeEnum {
    Embedded = 0,
    Email = 1
}

export { SignatureTypeEnum };
